import Image from '@/components/Image';
import Link from '@/components/Link';

export default function PostAuthor({
  trainer: { title, featuredImage, uri },
  position,
}) {
  return (
    <Link href={uri} className="flex items-center space-x-4">
      <div className="h-12 w-12">
        <Image
          alt={title}
          src={featuredImage.node.sourceUrl}
          className="block h-12 w-12 rounded-full"
        />
      </div>
      <div className="flex flex-col space-y-2 lg:space-y-0">
        <h4 className="m-0 text-base font-semibold leading-none lg:text-lg">
          {title}
        </h4>
        <div className="text-sm leading-none text-gray-500 lg:text-base">
          {position}
        </div>
      </div>
    </Link>
  );
}
